import { get } from '@util/xhrAPI'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { updateMissionPilots } from '@store/slice/missionSlice'
import Div from '@ui/layout/Div'
import { useEffect } from 'react'
import MissionPilotVign from './MissionPilotVign'

const MissionPilots = () => {
  const { missionPilots } = useSelector(state => state.mission)
  const { mission } = useSelector(state => state.main)
  const { id } = mission
  const [t] = useTranslation('mission')
  const dispatch = useDispatch()

  const renderMissionPilots = () => {
    if (!missionPilots) return <></>

    return missionPilots.map(pilot => <MissionPilotVign pilot={pilot} key={`mission-${id}-pilot`} />)
  }

  useEffect(() => {
    if (!missionPilots) {
      get(`${import.meta.env.VITE_API_URL}/api/users/missions/${id}/pilots`, response => {
        const { code, pilots, errors } = response
        if (200 === code) {
          dispatch(updateMissionPilots(pilots))
        } else {
          console.error(errors)
        }
      })
    }
  }, [])

  return (
    <Div cssClass='mission-pilots'>
      <h2 className='scene-title'>{t('titles.mission_pilots')}</h2>
      <Div cssClass='pilots columns is-multiline'>
        {renderMissionPilots()}
      </Div>
    </Div>
  )
}

export default MissionPilots
